/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S7_P2Inputs */

const tr_servis_s7_p2 = /** @type {(inputs: Servis_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni alt yükleniciye makul bir gerekçe ile itiraz etmeniz halinde taraflar iyi niyetle bir çözüm arar; çözüm bulunamaması halinde Kullanıcı aboneliği feshedebilir.`)
};

const en_servis_s7_p2 = /** @type {(inputs: Servis_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you object to the new sub-processor on reasonable grounds, the parties shall seek a solution in good faith; if no solution can be found, the User may terminate the subscription.`)
};

const de_servis_s7_p2 = /** @type {(inputs: Servis_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie dem neuen Unterauftragsverarbeiter mit einer angemessenen Begründung widersprechen, suchen die Parteien nach Treu und Glauben eine Lösung; kann keine Lösung gefunden werden, kann der Nutzer das Abonnement kündigen.`)
};

const ru_servis_s7_p2 = /** @type {(inputs: Servis_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если вы возражаете против нового субподрядчика по обоснованной причине, стороны добросовестно ищут решение; при отсутствии решения Пользователь может расторгнуть подписку.`)
};

/**
* | output |
* | --- |
* | "If you object to the new sub-processor on reasonable grounds, the parties shall seek a solution in good faith; if no solution can be found, the User may term..." |
*
* @param {Servis_S7_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s7_p2 = /** @type {((inputs?: Servis_S7_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S7_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s7_p2(inputs)
	if (locale === "de") return de_servis_s7_p2(inputs)
	if (locale === "ru") return ru_servis_s7_p2(inputs)
	return tr_servis_s7_p2(inputs)
});